import { post } from "@/utils/utils";
import moment from "moment";
 
const product = {
  state: {
    productList: {
      list: [],
      total: 0
    },
    addProductCode: "",
    editProductCode: "",
    deleteProductCode: "",
    rowProduct: {},
    categoryList: [],
    addCategoryCode: "",
    editCategoryCode: "",
    deleteCategoryCode: "",
    commondityList: {
      list: [],
      total: 0
    },
    virtualCommodityList: []
  },
  mutations: {
    PRODUCT_LIST(state, data) {
      state.productList = data.result;
      state.productList.list.forEach(v => {
        v.validStartDateFormat = v.validStartDate
          ? moment(v.validStartDate).format("YYYY-MM-DD")
          : "";
        v.validEndDateFormat = v.validEndDate
          ? moment(v.validEndDate).format("YYYY-MM-DD")
          : "";
      });
    },
    QUERY_COMMODITY_LIST(state, data) {
      state.commondityList = data.result;
    },
    ADD_PRODUCT(state, data) {
      state.addProductCode = data.result;
    },
    EDIT_PRODUCT(state, data) {
      state.editProductCode = data.result;
    },
    DELETE_PRODUCT(state, data) {
      state.deleteProductCode = data.result;
    },
    ROW_PRODUCT(state, data) {
      state.rowProduct = data.result;
    },
    CATEGORY_LIST(state, data) {
      state.categoryList = data.result;
    },
    ADD_CATEGORY(state, data) {
      state.addCategoryCode = data.result;
    },
    EDIT_CATEGORY(state, data) {
      state.editCategoryCode = data.result;
    },
    DELETE_CATEGORY(state, data) {
      state.deleteCategoryCode = data.result;
    },
    QUERY_VIRTUAL_COMMODITY(state, data) {
      state.virtualCommodityList = data.result;
    }
  },
  actions: {
    queryProductList({ commit }, params) {
      return post({
        commit,
        url: `/server-back/server_card_list`,
        name: "PRODUCT_LIST",
        params
      });
    },
    queryRowProduct({ commit }, params) {
      return post({
        commit,
        url: `/server-back/server_product_detail`,
        name: "ROW_PRODUCT",
        params
      });
    },
    queryVirtualCommodity({ commit }, params) {
      return post({
        commit,
        url: `/server-back/server_fictitious_list`,
        name: "QUERY_VIRTUAL_COMMODITY",
        params
      });
    },
    queryCommodityList({ commit }, params) {
      return post({
        commit,
        url: `/server-back/server_product_list`,
        name: "QUERY_COMMODITY_LIST",
        params
      });
    },
    addProduct({ commit }, params) {
      return post({
        commit,
        url: `/server-back/add_server_info`,
        name: "ADD_PRODUCT",
        params
      });
    },
    editProduct({ commit }, params) {
      return post({
        commit,
        url: `/server-back/update_server_info`,
        name: "EDIT_PRODUCT",
        params
      });
    },
    deleteProduct({ commit }, params) {
      return post({
        commit,
        url: `/server-back/delete_server_info`,
        name: "DELETE_PRODUCT",
        params
      });
    },
    queryCategoryList({ commit }, params) {
      return post({
        commit,
        url: `/server-back/server_category_list`,
        name: "CATEGORY_LIST",
        params
      });
    },
    addCategory({ commit }, params) {
      return post({
        commit,
        url: `/server-back/add_category`,
        name: "ADD_CATEGORY",
        params
      });
    },
    editCategory({ commit }, params) {
      return post({
        commit,
        url: `/server-back/update_category`,
        name: "EDIT_CATEGORY",
        params
      });
    },
    deleteCategory({ commit }, params) {
      return post({
        commit,
        url: `/server-back/delete_category`,
        name: "DELETE_CATEGORY",
        params
      });
    }
  }
};

export default product;
